import { SideNavItem } from "@design-system/SideNav/SideNavItem";
import { WorkIcon } from "@icons";
import styles from "./ActionsRow.module.scss";

interface ActionsRowProps {
    to: string;
    /** Open task count; it hides while undefined (loading) or at 0. */
    count: number | undefined;
    end?: boolean;
    shortcut?: string;
    /** Overrides the route match, e.g. off while a more specific row is active. */
    isActive?: boolean;
}

/** The Actions row's `trailing` count, plain text that darkens while the row is active. */
export const taskCountTrailing =
    (count: number) =>
    ({ isActive }: { isActive: boolean }) => (
        <span className={styles.count} data-active={isActive || undefined}>
            {count}
        </span>
    );

/** The Actions row, shared by the workspace and org navs. Its count shows on hover or focus. */
export const ActionsRow = ({
    to,
    count,
    end,
    shortcut,
    isActive,
}: ActionsRowProps) => {
    const hasTodoTasks = count !== undefined && count > 0;

    return (
        <SideNavItem
            to={to}
            end={end}
            isActive={isActive}
            icon={<WorkIcon />}
            label="Actions"
            shortcut={shortcut}
            trailing={hasTodoTasks ? taskCountTrailing(count) : undefined}
            trailingVisibility="reveal"
        />
    );
};
